/**
 * @desc test3
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(mailAccountCode: string | number, uid: string | number, options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/sync/${mailAccountCode}/${uid}`, {
      method: "POST",

      ...options,
    }),
  );
}
